import Icon$1 from "./component-library155.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library156.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "EnergyLabelIcon",
  components: { LinkButton, Icon: Icon$1 },
  props: {
    energyClass: {
      type: String,
      required: true
    },
    noButton: { type: Boolean },
    reverse: { type: Boolean }
  },
  emits: ["click"],
  data() {
    return {
      componentTexts: {
        linkTitle: "Energieeffizienz"
      }
    };
  },
  computed: {
    containerClass() {
      return {
        "energy-label-icon--has-link": !this.noButton
      };
    },
    title() {
      return `${this.componentTexts.linkTitle} ${this.energyClass}`;
    }
  },
  methods: {
    emitClick() {
      if (this.noButton)
        return;
      this.$emit("click");
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("LinkButton", { staticClass: "energy-label-icon", class: _vm.containerClass, attrs: { "aria-label": `Energieeffizienz ${_vm.energyClass}`, "tag": "button", "type": "button", "no-styling": "" }, on: { "click": function($event) {
    $event.stopPropagation();
    $event.preventDefault();
    return _vm.emitClick.apply(null, arguments);
  } } }, [_c("Icon", { attrs: { "energy-class": _vm.energyClass, "reverse": _vm.reverse } }), _vm._t("lightbox", null, { "title": _vm.title })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "4a01c48f",
  null,
  null
);
const Icon = __component__.exports;
export {
  Icon as default
};
